import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'
import { isRtl } from 'src/helper/tool'

export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { language, list, lang, myrank, rewardData } = this.props
    let rankingData = rewardData.sort((a, b) => b.score - a.score)
    console.log(rankingData, 'rankingData');

    return (
      <div className="userList">
        <div className="listTop"></div>
        <div className="bd">
          <div className={`list ${isRtl(language) && 'arlang'}`}>
            <div className={`listuser ${isRtl(language) && 'arlang'}`}>

              <div className="ruby-ranking-midle">

                <div className="ruby-ranking-top">
                  {rankingData.slice(0, 3).map((item, index) => (
                    <div>
                      <div className="ruby-ranking-img" >
                        <img src={item.avatarurl} />
                      </div>
                      <p>{item.nickname}</p>
                      <span>ID: {item.uid}</span>
                    </div>

                  ))}
                </div>

                {rankingData.map((item, index) => (
                  <div className="ruby-ranking-midle-conten" key={index}>
                    <div>
                      <span>{index + 4}</span>
                      <img src={item.avatarurl} />
                      <div className="ruby-ranking-midle-word">
                        <p>{item.nickname}</p>
                        <span>{item.uid}</span>
                      </div>
                    </div>
                    <p>{item.score}M</p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
        <div className="listBottom">

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/List/index.js